import { CheckCircle2, ShieldAlert } from "lucide-react";
import type { Attack } from "@/live/model";
import { formatDuration } from "@/lib/format";
import { Badge } from "./ui/Badge";

export function AttackStateBadge({ attack }: { attack: Attack }) {
  return attack.state === "active" ? (
    <Badge tone="critical" icon={<ShieldAlert className="size-3" aria-hidden />}>
      Đang diễn ra
    </Badge>
  ) : (
    <Badge tone="good" icon={<CheckCircle2 className="size-3" aria-hidden />}>
      Đã kết thúc
    </Badge>
  );
}

export function attackDuration(a: Attack, nowMs: number): string {
  if (a.startedAtMs === undefined) return "không rõ";
  return formatDuration(((a.endedAtMs ?? nowMs) - a.startedAtMs) / 1000);
}

/** How far observed traffic exceeded the learned baseline, e.g. "×42". */
export function surgeFactor(a: Attack): string | null {
  // Only meaningful at detection time; an END-only record has no peak.
  const peak = a.startPps;
  if (!peak || a.baselinePps <= 0) return null;
  const f = peak / a.baselinePps;
  return f >= 10 ? `×${Math.round(f)}` : `×${f.toFixed(1).replace(".", ",")}`;
}
